import React from 'react';

const Loading = () => {
  return (
    <div className='fixed inset-0 w-full h-screen bg-black/70 flex justify-center items-center z-50'>
      <div className='flex flex-col items-center'>
        <p className='text-white text-2xl font-bold'>
          Consultando en base de datos de SUNAT...Por favor espere.
        </p>
      </div>
    </div>
  );
};

export default Loading;
